<template>
  <div>
    <!-- Sections  latest-video-->
    <section class="latest-video">
      <div class="container">
        <div class="main-heading text-center">
          <h1>Latest Videos</h1>
        </div>
        <div class="row">
          <div v-if="videoData.length == 0">
            <p class="text-center" style="color:black;">No Data Available !</p>
          </div>
          <div
            v-else
            class="col-xs-12 col-sm-6 col-md-4 video-data"
            v-for="v in videoData"
            :key="v._id"
            v-match-heights="{
              el: ['.video-data .video-title'],
              disabled: [575]
            }"
          >
            <figure class="thumbnail text-center" :id="v.atheleteMainProfileId">
              <video-embed
                :src="v.videoUrl"
                sandbox="allow-scripts allow-same-origin allow-presentation"
              ></video-embed>
              <a class="color-secondary" href="javascript:;">
                <figcaption class="video-title">{{ v.videoDesc }}</figcaption>
              </a>
            </figure>
          </div>
        </div>
        <div
          v-if="videoData.length != 0 && !public"
          class="col-md-12 text-center view-all"
        >
          <button
            type="button"
            class="btn btn-default text-center"
            @click="handleViewAll"
          >
            View All
          </button>
        </div>
      </div>
    </section>
    <!-- /.sections  /.latest-video-->
  </div>
</template>

<script>
export default {
  props: {
    videoData: {
      type: Array
    },
    public: {
      type: Boolean
    },
    viewAll: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleViewAll() {
      this.$emit("view-all");
    }
  }
};
</script>

<style lang="scss" scoped></style>
